import axios from "axios";

export const GET_ALL = "medics_self_registrations";

export function getAllInAuthorize(pageNumber) {
    return axios.get(`${GET_ALL}?page=${pageNumber}`);
}

export function getMedicById(medicId) {
    return axios.get(`${GET_ALL}/${medicId}`);
}

export function updateMedicById(medicId, authorized) {
    return axios.put(`${GET_ALL}/${medicId}?authorized=${authorized}`);
}


export function getAllInAuthorizeFilter(body, pageNumber) {
    return axios.post(`${GET_ALL}?page=${pageNumber}`, body);
}

const MEXICAN_STATES = [
    { name: "AGUASCALIENTES" }, { name: "BAJA CALIFORNIA" }, { name: "BAJA CALIFORNIA SUR" },
    { name: "CAMPECHE" }, { name: "CHIAPAS" }, { name: "CHIHUAHUA" },
    { name: "CIUDAD DE MEXICO" }, { name: "COAHUILA DE ZARAGOZA" }, { name: "COLIMA" },
    { name: "DURANGO" }, { name: "GUANAJUATO" }, { name: "GUERRERO" },
    { name: "HIDALGO" }, { name: "JALISCO" }, { name: "MEXICO" },
    { name: "MICHOACAN DE OCAMPO" }, { name: "MORELOS" }, { name: "NAYARIT" },
    { name: "NUEVO LEON" }, { name: "OAXACA" }, { name: "PUEBLA" },
    { name: "QUERETARO" }, { name: "QUINTANA ROO" }, { name: "SAN LUIS POTOSI" },
    { name: "SINALOA" }, { name: "SONORA" }, { name: "TABASCO" },
    { name: "TAMAULIPAS" }, { name: "TLAXCALA" }, { name: "VERACRUZ DE IGNACIO DE LA LLAVE" },
    { name: "YUCATAN" }, { name: "ZACATECAS" },
];

export function getStates() {
    const { REACT_APP_POSTAL_CODE_MEX_BASE_URL, REACT_APP_POSTAL_CODE_MEX_API_KEY } = process.env;

    return axios.get(`${REACT_APP_POSTAL_CODE_MEX_BASE_URL}/estados`, {
        headers: {
            'Authorization': 'Bearer ' + REACT_APP_POSTAL_CODE_MEX_API_KEY,
        },
        skipInterceptor: true
    }).catch(() => ({ data: MEXICAN_STATES }));
}
